import React from 'react';
import { BasicButton, Radio } from '../../UI';
import { getPrimary, getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';
import { getText } from '../../utils/functions';
import {
	CONFIRMATION_AGENDAS,
	CONFIRMATION_ITEMS_AGENDA,
	CUSTOM_ABSTENTION_AGENDAS, CUSTOM_AGENDAS, DEFAULT_AGENDAS, DEFAULT_ITEMS_AGENDA, INFORMATIVE_AGENDAS,
	VOTE_VALUES
} from '../../utils/constants';
import BlockTitle from '../../UI/BlockTitle';

const buildDefaultSensesObject = (portal, defaultValue) => {
	const votes = [];
	Object.values(portal.council.agendas).forEach(agenda => {
		if (agenda.subjectType !== INFORMATIVE_AGENDAS) {
			const defVoteSense = portal.config?.defaultVoteSense;

			const hasArrayValue = portal.council.agendas
				.find(agen => agen.id === agenda.id).options?.maxSelections > 1;

			if ([...CUSTOM_AGENDAS, CONFIRMATION_AGENDAS]?.includes(agenda.subjectType)) {
				if (defaultValue === VOTE_VALUES.ABSTENTION) {
					votes.push({ id: agenda.id, orderIndex: agenda.orderIndex, value: hasArrayValue ? [VOTE_VALUES.ABSTENTION] : VOTE_VALUES.ABSTENTION });
				} else {
					votes.push({
						id: agenda.id,
						orderIndex: agenda.orderIndex,
						value: hasArrayValue ?
							// Must change this line in the future for correctly functioning of multiple votes
							defVoteSense.custom?.find(customAgenda => customAgenda.id === agenda.id)?.value
							:
							defVoteSense.custom?.find(customAgenda => customAgenda.id === agenda.id)?.value
					});
				}
			} else {
				// yes, no or abstention
				votes.push({ id: agenda.id, orderIndex: agenda.orderIndex, value: defaultValue });
			}
		}
	});

	return {
		...portal,
		config: {
			...portal.config,
			defaultVoteSense: {
				...portal.config?.defaultVoteSense,
				general: defaultValue,
				custom: [
					...votes
				]
			}
		}
	};
};

// Borra pero en los valores iguales a los custom aunque esten undefined se checkean, mirar checks
const resetAgendaVotes = (localState, agendaId) => ({
	...localState,
	config: {
		...localState.config,
		defaultVoteSense: {
			...localState.config?.defaultVoteSense,
			custom: [
				...localState.config?.defaultVoteSense?.custom
					?.filter(agenda => agenda.id !== agendaId)
			]
		}
	}
});


const PortalVoteSense = ({
	portal,
	updateState,
	translate,
}) => {
	const [localState, setLocalState] = React.useState(portal);
	const [agendas, setAgendas] = React.useState(portal?.council?.agendas);

	/* Formats items from server structure to value, text, label structure */
	const formatCustomItems = items => [...items.map(item => ({ value: item.id, text: '', label: item.value })), CUSTOM_ABSTENTION_AGENDAS];

	/* Agenda items */
	React.useEffect(() => {
		const agendaArray = [];
		Object.values(portal.council.agendas)
			.filter(agenda => agenda.subjectType !== INFORMATIVE_AGENDAS)
			.forEach(agenda => {
				if (agenda.items?.length > 0) {
					agendaArray.push({
						...agenda,
						items: formatCustomItems(agenda.items)
					});
					return;
				}
				if (DEFAULT_AGENDAS.includes(agenda.subjectType)) {
					agendaArray.push({
						...agenda,
						items: DEFAULT_ITEMS_AGENDA
					});
					return;
				}
				if (agenda.subjectType === CONFIRMATION_AGENDAS) {
					agendaArray.push({
						...agenda,
						items: CONFIRMATION_ITEMS_AGENDA
					});
					return;
				}
				agendaArray.push(agenda);
			});
		setAgendas(agendaArray);
	}, [portal?.council?.agendas]);

	const modifyCustomVotes = (agendaId, value) => {
		// Preproccesing value
		let newValue = value;
		if (Array.isArray(value)) {
			// New value in a multiple agenda
			newValue = [Object.values(value)[0]];
			if (localState?.config?.defaultVoteSense?.custom.length !== 0) {
				// Default values in a agenda(localState)
				let multipleValues = Object.values(localState?.config?.defaultVoteSense?.custom)
					.find(agen => agen.id === agendaId);
				if (multipleValues !== undefined && multipleValues.value !== undefined) {
					[multipleValues] = [multipleValues.value];
					if (!multipleValues?.includes(value[0]) && !multipleValues?.includes(VOTE_VALUES.ABSTENTION)) {
						const maxOptions = portal.council.agendas
							.find(agen => agen.id === agendaId)?.options?.maxSelections;
						if (maxOptions > multipleValues.length
							|| (maxOptions === multipleValues.length && newValue[0] === VOTE_VALUES.ABSTENTION)) {
							if (newValue[0] === VOTE_VALUES.ABSTENTION) {
								newValue = [VOTE_VALUES.ABSTENTION];
							} else {
								newValue = newValue.concat(multipleValues);
							}
						} else {
							newValue = multipleValues;
						}
					}
				}
			}
		}
		// Setting custom votes in agenda
		setLocalState({
			...localState,
			config: {
				...localState.config,
				defaultVoteSense: {
					...localState.config?.defaultVoteSense,
					custom: [
						...localState.config?.defaultVoteSense?.custom
							?.filter(agenda => agenda.id !== agendaId),
						{
							id: agendaId,
							value: newValue,
						}
					]
				}
			}
		});
	};

	const getCustomVote = agendaId => localState.config?.defaultVoteSense.custom
		?.find(agenda => agenda.id === agendaId);

	const renderForm = () => (
		<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
			{/* GENERAL VOTE */}
			<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
				<BlockTitle text={'Sentido del voto general'} style={{ fontSize: '1.1rem' }} />
				<div style={{ display: 'flex', gap: '1rem' }}>
					{DEFAULT_ITEMS_AGENDA.map(voteItem => (
						<Radio
							key={voteItem.value}
							styleLabel={{ margin: '0' }}
							name="generalVoteSense"
							label={getText(voteItem, translate)}
							value={voteItem.value}
							checked={localState?.config?.defaultVoteSense?.general === voteItem.value}
							onChange={() => setLocalState(buildDefaultSensesObject(localState, voteItem.value))}
						/>
					))}
				</div>
				<BlockTitle text={'Sentidos de los votos'} style={{ fontSize: '1.1rem' }} />
				<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
					{agendas.map(agenda => (
						<React.Fragment key={agenda.id}>
							<div style={{ display: 'flex' }}>
								<BlockTitle text={agenda.agendaSubject} style={{ fontWeight: 'normal' }} />
								<div>
									<BasicButton
										key={agenda.id}
										name='voteSenseReset'
										color='#7d2180'
										text='Limpiar sentido del voto'
										onClick={() => { setLocalState(resetAgendaVotes(localState, agenda.id)); }}
										buttonStyle={{
											border: 'solid 1px',
											marginLeft: '1em',
											padding: '0 0.7em',
											minWidth: '20px',
											maxHeight: '25px',
											color: 'white',
											whiteSpace: 'nowrap'
										}}
									/>
								</div>
							</div>
							<div style={{ display: 'flex', gap: '1rem' }}>
								{agenda.items.map(voteItem => {
									// Check if the agenda with the corresponding id has multiple values
									const hasArrayValue = portal.council.agendas
										.find(agen => agen.id === agenda.id)?.options?.maxSelections > 1;
									return <Radio
										key={voteItem.value}
										styleLabel={{ margin: '0' }}
										name="voteSense"
										label={getText(voteItem, translate)}
										value={hasArrayValue ? voteItem.value[0] : voteItem.value}
										onChange={() => modifyCustomVotes(
											agenda.id,
											hasArrayValue ? [voteItem.value] : voteItem.value
										)}
										checked={hasArrayValue ?
											getCustomVote(agenda.id)?.value?.includes(voteItem.value)
											|| (((localState?.config?.defaultVoteSense?.general === voteItem?.value
												&& getCustomVote(agenda?.id)?.value[0] === undefined))
												&& localState.config.defaultVoteSense.custom
													.includes(agen => agen.id === agenda.id))
											:
											getCustomVote(agenda.id)?.value === voteItem.value
											|| (((localState?.config?.defaultVoteSense?.general === voteItem?.value
												&& getCustomVote(agenda?.id)?.value === undefined))
												&& localState.config.defaultVoteSense.custom
													.includes(agen => agen.id === agenda.id))
										}
									/>;
								})}
							</div>
						</React.Fragment>
					))}
				</div>
			</div>
			<div style={{ minWidth: 'max-content' }}>
				<BasicButton
					color='white'
					text={'Borrar sentidos de voto'}
					onClick={() => setLocalState({
						...localState,
						config: {
							...localState?.config,
							defaultVoteSense: {
								general: null,
								custom: []
							}
						}
					})}
					backgroundColor={{
						backgroundColor: getPrimary(),
						border: `1px solid ${getPrimary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			</div>
		</div>
	);

	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							...localState,
						});
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

export default PortalVoteSense;
